/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Provenienza dell\'ISEE usato per la tariffa mensa
 */
export enum FonteIseeTariffa {

    ANNO_ESATTO = 'ANNO_ESATTO',

    ULTIMO_DISPONIBILE = 'ULTIMO_DISPONIBILE',

    DOMANDA = 'DOMANDA'
}

